import React from 'react';
import PropTypes from 'prop-types';
import cls from 'classname';

export const Sun = ({ width, height, className, outline /* , fill */ }) =>
  !outline ? (
    <svg
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      className={cls(className, 'icon icon-sun icon-sun-outline')}
      viewBox="0 0 24 24"
      stroke="#4b94fc"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="5"></circle>
      <line x1="12" y1="1" x2="12" y2="3"></line>
      <line x1="12" y1="21" x2="12" y2="23"></line>
      <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
      <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
      <line x1="1" y1="12" x2="3" y2="12"></line>
      <line x1="21" y1="12" x2="23" y2="12"></line>
      <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
      <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
    </svg>
  ) : (
    <svg
      width={width}
      height={height}
      // viewBox="0 0 16 16"
      className={cls(className, 'icon-sun-bold')}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      stroke={'#fff'}
      fill={'#fff'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="5"></circle>
      <line x1="12" y1="1" x2="12" y2="3"></line>
      <line x1="12" y1="21" x2="12" y2="23"></line>
      <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
      <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
      <line x1="1" y1="12" x2="3" y2="12"></line>
      <line x1="21" y1="12" x2="23" y2="12"></line>
      <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
      <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
    </svg>
  );

Sun.defaultProps = {
  width: 16,
  height: 16,
  // fill: '#6E7DAE',
  outline: true,
};

Sun.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string,
  // fill: PropTypes.string,
  outline: PropTypes.bool,
};

export default Sun;
